export default "__VITE_ASSET__DAtNaDo3__"